import React, { useCallback, useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";

// Style
import "../../../style/home/Video.scss";

export const breakpoints = {
  mobile: `(max-width: 768px)`,
  tablet: `(min-width: 769px) and (max-width: 1199px)`,
  desktop: `(min-width: 1200px)`,
};

const Video = () => {
  const isMobile = useMediaQuery({ query: breakpoints.mobile });
  const [isMuted, setIsMuted] = useState(true);
  const iframeRef = useRef(null);

  const vimeoPlayerId = "arena-mobile-video";
  const youtubeOrigin = "https://www.youtube.com";
  const vimeoOrigin = "https://player.vimeo.com";
  const desktopVideoSrc =
    "https://www.youtube.com/embed/eNz0WDmsD8w?si=GkTR7jRAiL_NDs39&autoplay=1&mute=1&controls=0&rel=0&modestbranding=1&playsinline=1&loop=1&playlist=eNz0WDmsD8w&enablejsapi=1";
  const mobileVideoSrc = `https://player.vimeo.com/video/1119098171?badge=0&autopause=0&player_id=${vimeoPlayerId}&app_id=58479&autoplay=1&muted=1&playsinline=1&loop=1&api=1`;

  const videoSrc = isMobile ? mobileVideoSrc : desktopVideoSrc;

  const postToYouTube = useCallback(
    (command) => {
      if (!iframeRef.current?.contentWindow) {
        return;
      }

      iframeRef.current.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: command,
          args: [],
        }),
        youtubeOrigin
      );
    },
    [youtubeOrigin]
  );

  const postToVimeo = useCallback(
    (method, value) => {
      if (!iframeRef.current?.contentWindow) {
        return;
      }

      const message = JSON.stringify(
        value === undefined
          ? { method }
          : {
              method,
              value,
            }
      );

      iframeRef.current.contentWindow.postMessage(message, vimeoOrigin);
    },
    [vimeoOrigin]
  );

  useEffect(() => {
    // Reset to muted whenever we switch between desktop and mobile embeds
    setIsMuted(true);
  }, [isMobile]);

  useEffect(() => {
    if (!iframeRef.current) {
      return;
    }

    if (isMobile) {
      postToVimeo("setVolume", isMuted ? 0 : 1);
      if (!isMuted) {
        postToVimeo("play");
      }
    } else {
      postToYouTube(isMuted ? "mute" : "unMute");
      if (!isMuted) {
        postToYouTube("playVideo");
      }
    }
  }, [isMobile, isMuted, postToVimeo, postToYouTube]);

  const containerClassName = `videoContainer ${
    isMobile ? "mobile" : "desktop"
  }`;
  const iframeKey = isMobile ? "mobileVideo" : "desktopVideo";
  const iframeId = isMobile ? vimeoPlayerId : "arena-desktop-video";
  const videoTitle = isMobile
    ? "Arena mobile experience video"
    : "Arena desktop experience video";

  const handleToggleMute = () => {
    setIsMuted((prevMuted) => !prevMuted);
  };

  return (
    <section className="videoSectionHome">
      <div className={containerClassName}>
        {!isMobile && (
          <button
            type="button"
            className="muteToggle"
            onClick={handleToggleMute}
            aria-pressed={!isMuted}
            aria-label={isMuted ? "Unmute video" : "Mute video"}
          >
            {isMuted ? "Unmute" : "Mute"}
          </button>
        )}
        <iframe
          key={iframeKey}
          ref={iframeRef}
          id={iframeId}
          src={videoSrc}
          title={videoTitle}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default Video;
